<template>
  <div class="ContactButton">
    <div class="ContactButton--text">Contact</div>
    <div class="ContactButton--vector">
      <Vector :svg="icon.mail"></Vector>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactButton",
  data() {
    return {
      icon: {
        mail: require('@bbx/vector~master/core/assets/svg/material/mail.svg'),
      }
    }
  }
}
</script>

<style scoped>

/**/

.ContactButton {
  box-shadow: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #00AEB0;
  border: 1px solid rgba(0, 0, 0, 0);
  transition: background-color 300ms;
  padding: 4px 30px;
  border-radius: 50px;
  text-transform: uppercase;
}

.ContactButton:hover {
  background-color: #FFFFFF;
  border: 1px solid #00AEB0;
}

.ContactButton--text {
  color: #ffffff;
  font-size: 12px;
  line-height: 12px;
  position: relative;
  top: -1px;
  padding-right: 10px;
}

.ContactButton:hover .ContactButton--text {
  color: #00AEB0;
}

/**/

.ContactButton--vector >>> .Vector svg {
  transition: fill 300ms;
  fill: #ffffff;
  width: 20px;
  height: 20px;
}

.ContactButton:hover .ContactButton--vector >>> .Vector svg {
  fill: #00AEB0;
}
</style>



        